import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3599b159")

_pushScopeId("data-v-3599b159")
const _hoisted_1 = { class: "user-type" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "user-tit" }, "请选择与受送达人关系", -1)
const _hoisted_3 = { class: "one-Parent" }
const _hoisted_4 = { class: "one-Parent2" }
const _hoisted_5 = { class: "two1" }
const _hoisted_6 = { class: "two2" }
const _hoisted_7 = { class: "btn" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.selectOptions.userTypeList, (i, index) => {
        return (_openBlock(), _createBlock("div", {
          class: [i.code === $setup.userValue ? 'one1Che' : 'one1'],
          key: index,
          onClick: $event => ($setup.constUserTypeFun(i.code))
        }, [
          _createVNode("img", {
            src: [i.code === $setup.userValue ? i.imgChe : i.img],
            class: "imgs"
          }, null, 8, ["src"]),
          _createVNode("div", null, _toDisplayString(i.msg), 1)
        ], 10, ["onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createVNode("div", _hoisted_4, [
      _withDirectives(_createVNode("div", _hoisted_5, [
        _createVNode(_component_el_radio_group, {
          modelValue: $setup.proxyValue,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ($setup.proxyValue = $event))
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.selectOptions.userTypeOptions, (item) => {
              return (_openBlock(), _createBlock(_component_el_radio, {
                style: {"margin-top":"20px","display":"block"},
                key: item.value,
                label: item.value
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(item.label), 1 /* TEXT */)
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, $setup.userValue == 1]
      ]),
      _withDirectives(_createVNode("div", _hoisted_6, [
        _createVNode(_component_el_radio_group, {
          modelValue: $setup.proxyValue,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ($setup.proxyValue = $event))
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.selectOptions.proxyTypeOptions, (item) => {
              return (_openBlock(), _createBlock(_component_el_radio, {
                style: {"margin-top":"20px","display":"block"},
                key: item.value,
                label: item.value
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(item.label), 1 /* TEXT */)
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, $setup.userValue == 2]
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("button", {
        class: "btnSubmit",
        onClick: _cache[3] || (_cache[3] = (...args) => ($setup.nextusertypefun(...args)))
      }, "下一步")
    ])
  ]))
})